import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Services' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="navbar-content">
          <Link to="/" className="logo">
            <Logo size={48} />
            <span className="logo-text">
              <span className="logo-name">LOGIFOX</span>
              <span className="logo-tagline">INFOTECH</span>
            </span>
          </Link>

          <div className={`nav-links ${isOpen ? 'active' : ''}`}>
            <div className="drawer-header">
              <Link to="/" className="drawer-logo" onClick={() => setIsOpen(false)}>
                <Logo size={40} />
                <span className="logo-text">
                  <span className="logo-name">LOGIFOX</span>
                  <span className="logo-tagline">INFOTECH</span>
                </span>
              </Link>
              <button className="drawer-close" onClick={() => setIsOpen(false)}>
                <X size={24} />
              </button>
            </div>
            {navLinks.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                end={link.path === '/'}
                className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
              >
                {link.label}
              </NavLink>
            ))}
            <Link to="/contact" className="btn btn-primary nav-btn">
              Get Started
            </Link>
          </div>

          <button className="mobile-toggle" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
